import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading } from '../../components/Heading';
import { noOp } from '../../lib/utils';
import { FormulationRecommendations } from './FormulationRecommendations';
import { IngredientRecommendations } from './IngredientRecommendations';

type RecommendationsProps = {
  id?: string;
  onVisibilityChange?: (isVisible: boolean) => void;
};

export const Recommendations: FC<RecommendationsProps> = ({
  id = '',
  onVisibilityChange = noOp,
}) => {
  const { t } = useTranslation();
  const [isRecommendationsHeaderVisible, setIsRecommendationsHeaderVisible] =
    useState(false);
  // Initial amount of recommendations shown, before clicking the Show More button
  const INITIAL_LIMIT = 3;

  useEffect(() => {
    onVisibilityChange(isRecommendationsHeaderVisible);
  }, [isRecommendationsHeaderVisible, onVisibilityChange]);

  return (
    <>
      {isRecommendationsHeaderVisible && (
        <div id={id} className="mb-6">
          <div className="flex flex-grow justify-center flex-wrap xl:max-w-6xl font-regular">
            <div className="w-full sm:w-10/12 lg:w-8/12">
              <Heading
                level="h2"
                align="center"
                weight="medium"
                margin={0}
                text={t('components:success:recommendations:heading')}
              />
              <p className="text-center">
                {t('components:success:recommendations:subheading')}
              </p>
            </div>
          </div>
        </div>
      )}
      <FormulationRecommendations
        data-testid="formulation-recs"
        initialLimit={INITIAL_LIMIT}
        reportRecommendationsExist={setIsRecommendationsHeaderVisible}
      />

      <IngredientRecommendations
        initialLimit={INITIAL_LIMIT}
        reportRecommendationsExist={setIsRecommendationsHeaderVisible}
      />
    </>
  );
};
